module.exports = __webpack_public_path__ + "img/pic-2-5.1c289d60.png";